import React from 'react'
import PropTypes from 'prop-types'

import { Box, Typography } from '@mui/material'

const PreviewField = ({ isEditable = false, labelLeft = '', labelRight = '', leftProps = {}, rightProps = {}, ...rest }) => (
  <Box display="flex" alignItems="center" justifyContent="space-between" color={isEditable ? 'text.secondary' : 'text.primary'} {...rest}>
    <Typography {...leftProps}>{labelLeft}</Typography>
    <Typography {...rightProps}>{labelRight}</Typography>
  </Box>
)

PreviewField.propTypes = {
  isEditable: PropTypes.bool,
  labelLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelRight: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  leftProps: PropTypes.object,
  rightProps: PropTypes.object,
}

export default PreviewField
